/**
 * @generated SignedSource<<ea70ae3d39403410d648da1791037e0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DevicePlatform = "android" | "ios" | "web";
export type useRegisterDeviceMutation$variables = {
  buildVersion?: string | null;
  deviceId?: string | null;
  deviceModel?: string | null;
  deviceName?: string | null;
  devicePlatform?: DevicePlatform | null;
  token?: string | null;
  updateVersion?: string | null;
  versionUpdatedAt?: string | null;
};
export type useRegisterDeviceMutation$data = {
  readonly me: {
    readonly registerDevice: boolean | null;
  };
};
export type useRegisterDeviceMutation = {
  response: useRegisterDeviceMutation$data;
  variables: useRegisterDeviceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "buildVersion"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deviceId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deviceModel"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deviceName"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "devicePlatform"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "updateVersion"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionUpdatedAt"
},
v8 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MeMutation",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "buildVersion",
            "variableName": "buildVersion"
          },
          {
            "kind": "Variable",
            "name": "deviceId",
            "variableName": "deviceId"
          },
          {
            "kind": "Variable",
            "name": "deviceModel",
            "variableName": "deviceModel"
          },
          {
            "kind": "Variable",
            "name": "deviceName",
            "variableName": "deviceName"
          },
          {
            "kind": "Variable",
            "name": "devicePlatform",
            "variableName": "devicePlatform"
          },
          {
            "kind": "Variable",
            "name": "token",
            "variableName": "token"
          },
          {
            "kind": "Variable",
            "name": "updateVersion",
            "variableName": "updateVersion"
          },
          {
            "kind": "Variable",
            "name": "versionUpdatedAt",
            "variableName": "versionUpdatedAt"
          }
        ],
        "kind": "ScalarField",
        "name": "registerDevice",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useRegisterDeviceMutation",
    "selections": (v8/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "useRegisterDeviceMutation",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "bb3b2a8ef04ebb22c3e81b496aa9ec49",
    "id": null,
    "metadata": {},
    "name": "useRegisterDeviceMutation",
    "operationKind": "mutation",
    "text": "mutation useRegisterDeviceMutation(\n  $token: String\n  $devicePlatform: DevicePlatform\n  $deviceName: String\n  $deviceModel: String\n  $deviceId: String\n  $buildVersion: String\n  $updateVersion: String\n  $versionUpdatedAt: String\n) {\n  me {\n    registerDevice(token: $token, devicePlatform: $devicePlatform, deviceName: $deviceName, deviceModel: $deviceModel, deviceId: $deviceId, buildVersion: $buildVersion, updateVersion: $updateVersion, versionUpdatedAt: $versionUpdatedAt)\n  }\n}\n"
  }
};
})();

(node as any).hash = "0655644cc1ab26d6dada986631f663bf";

export default node;
